import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { MenuData } from '../models/menu-data';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

@Component({
    selector: 'tidy-menu-top-buttons',
    templateUrl: 'tidy-menu-top-buttons.component.html',
    styleUrls: ['./tidy-menu-top-buttons.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TidyMenuTopButtonsComponent  {

  @Input() menuData: MenuData;

  constructor(
    private navCtrl: CustomNavController,
    private menu: MenuController
  ) {
  }

  async goTo(target) {
    await this.menu.close();
    this.navCtrl.navigateForward(target);
  }
 }
